import { Fragment } from 'react';
import { StaticRichTextRenderer } from '@/shared/features/rich-text';
import { tokenizeAiBuilderInlineMarkdown } from '../utils/aiBuilderAssistantMarkdown';

/**
 * bold(**)/italic(*_) 인라인 마크다운 + `$...$`/`$$...$$` 수식 텍스트 렌더러.
 * key 관리를 내장한다.
 */
export const AiBuilderInlineMarkdown = ({
  text
}: {
  text: string;
}) => <>
    {tokenizeAiBuilderInlineMarkdown(text).map((token, tokenIndex) => {
    if (token.type === 'math') {
      return <StaticRichTextRenderer key={tokenIndex}
      // ZWSP 래핑은 latex 내용 형태와 무관하게(줄바꿈·공백 포함) 렌더러가
      // 항상 수식으로 재파싱하게 보장한다. display 수식만 `$$` 구분자 필요.
      text={token.display ? `\u200B$$${token.latex}$$\u200B` : `\u200B${token.latex}\u200B`} />;
    }
    if (token.type === 'bold') {
      return <strong key={tokenIndex} className="font-bold">
            {token.text}
          </strong>;
    }
    if (token.type === 'italic') {
      return <em key={tokenIndex} className="italic">
            {token.text}
          </em>;
    }
    return <Fragment key={tokenIndex}>{token.text}</Fragment>;
  })}
  </>;